import React from 'react'
import sortBy from 'lodash/sortBy'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FilterInput from '../../../FilterInput'
import { useStyles } from '../../styles'
import { ALL_TIME_PERIOD_FILTER, PERIOD_TYPE_FILTERS } from '../../../../constants/common'
import { MENU_PROPS } from '../../../../constants/theme'

const Filters = ({ data, waveFilterValue, handleWaveFilterChange, periodFilterValue, handlePeriodFilterChange }) => {
  const classes = useStyles()
  return (
    <Grid container item xs={12} className={classes.filters}>
      <Select MenuProps={MENU_PROPS} value={waveFilterValue.id} onChange={null} input={<FilterInput />} className={classes.nonDefault}>
        {sortBy(data.coordinator.wave.list, 'name').map(item => {
          return (
            <MenuItem key={item.id} onClick={() => handleWaveFilterChange(item)} value={item.id} className={classes.menuItem}>
              {item.name}
            </MenuItem>
          )
        })}
      </Select>
      <Select
        MenuProps={MENU_PROPS}
        value={periodFilterValue.id}
        onChange={null}
        input={<FilterInput />}
        className={periodFilterValue.id === ALL_TIME_PERIOD_FILTER.id ? classes.dropdownSelect : classes.nonDefault}
      >
        {PERIOD_TYPE_FILTERS.map(item => {
          return (
            <MenuItem key={item.id} onClick={() => handlePeriodFilterChange(item)} value={item.id} className={classes.menuItem}>
              {item.name}
            </MenuItem>
          )
        })}
      </Select>
      <div className={classes.divider} />
    </Grid>
  )
}

export default Filters
